import React from 'react';
import styled from 'styled-components';

const StartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  text-align: center;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #4169E1;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
`;

const Subtitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 2rem;
  color: #2C3E50;
`;

const StartButton = styled.button`
  background-color: #FF9500;
  color: white;
  font-size: 1.2rem;
  padding: 15px 40px;
  border-radius: 30px;
  margin-top: 2rem;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 12px rgba(255, 149, 0, 0.3);
  }
`;

const Decoration = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  overflow: hidden;
  
  &::before, &::after {
    content: '';
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    opacity: 0.1;
  }
  
  &::before {
    background-color: #4169E1;
    top: -100px;
    right: -100px;
  }
  
  &::after {
    background-color: #FF9500;
    bottom: -100px;
    left: -100px;
  }
`;

const StartScreen = ({ onStart }) => {
  return (
    <StartContainer>
      <Decoration />
      <Title>Η Ελληνική Οικονομία μετά την Επανάσταση</Title>
      <Subtitle>Διαδραστικό Κουίζ Γνώσεων</Subtitle>
      <p>Δοκίμασε τις γνώσεις σου με 10 ερωτήσεις σχετικά με την οικονομική ιστορία της Ελλάδας μετά την Επανάσταση του 1821!</p>
      <StartButton onClick={onStart}>Ξεκίνα το Κουίζ! 🚀</StartButton>
    </StartContainer>
  );
};

export default StartScreen;
